import { useParams } from 'react-router-dom';

// import { Doc } from '../../docs/components/Doc';
import { DocBrno } from '../../docs/components/DocBrno';
import { PrejimkaMenu } from '../../prejimka/prejimkamenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';

/**
 *
 * Prejimka se vyskytuje pouze u zakaznika MM Brno
 * zaloha ponechana
 */
const PrejimkaDocDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const { apps } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.prejimka ? (
        <AppWrapper
          appType={APP_TYPE.PREJIMKA}
          menu={<PrejimkaMenu />}
        >
          {/* <Doc docId={parseInt(id!, 10)} /> */}
          <DocBrno docId={parseInt(id!, 10)} />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default PrejimkaDocDetailPage;
